module.exports = __webpack_public_path__ + "static/webriq-logo-e97eb94ce48268990f67306ab305c73f.png";